export default __webpack_public_path__ + "static/media/product-screen-en.a6a6c4aa.png";